// extracted by mini-css-extract-plugin
export default {"viewItem":"view-form_viewItem__8VgqE","viewItemValue":"view-form_viewItemValue__OKCfW"};